import type { Team } from "@/types";

interface TeamBadgeProps {
  team: Team;
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: "w-8 h-8 text-[10px]",
  md: "w-12 h-12 text-xs",
  lg: "w-20 h-20 text-lg",
};

export default function TeamBadge({ team, size = "md" }: TeamBadgeProps) {
  return (
    <div
      className={`${sizeMap[size]} rounded-full flex items-center justify-center font-heading font-bold tracking-wide text-white shrink-0`}
      style={{
        backgroundColor: team.color,
        boxShadow: `inset 0 0 0 3px ${team.secondaryColor}33`,
      }}
      aria-label={team.fullName}
      title={team.fullName}
    >
      {team.abbreviation}
    </div>
  );
}